import React, { FunctionComponent, useMemo } from 'react';

import dateToString from '@ps-int/ufo-helpers/lib/date/date-to-string';
import cn from 'classnames';

import { useActions } from '../../../../../../shared/hooks';
import { useOnMount } from '../../../../../../shared/hooks/useOnMount';
import { getDatesBounds } from '../../../../helpers/get-dates-bounds';
import { useIsMobileOneColLayout } from '../../../../hooks';
import { setFilterFromTo } from '../../slice';
import { DatePicker } from '../date-picker';
import styles from './styles.css';

export const FilterDatePicker: FunctionComponent = () => {
    const datesBounds = useMemo(getDatesBounds, []);
    const actions = useActions({ setFilterFromTo });
    useOnMount(() => {
        const formattedTo = dateToString(datesBounds.to, 'YYYY-MM-DD');
        actions.setFilterFromTo({ from: formattedTo, to: formattedTo });
    });
    const isOneColLayout = useIsMobileOneColLayout();
    return (
        <DatePicker
            className={cn(styles.filterDatePicker, { [styles.oneColLayout]: isOneColLayout })}
            bounds={['from', 'to']}
            defaultDate={datesBounds.to}
        />
    );
};
